<template>
  <div class="min-w-fit">
    <v-select
      v-model="localValue"
      class="text-center border-md rounded-xl"
      bg-color="white"
      :items="omniTypes"
      :item-props="omniItemProps"
      hide-details
      @update:model-value="handleChange"
    >
      <template #selection="{ item }">
        <div v-if="item.value == 0" class="d-flex justify-center">
          {{ $t("reports.filters.all") }}
        </div>
        <v-icon v-else>
          {{ getMediaIcon(item.value) }}
        </v-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'FilterOmniSelect',
  props: {
    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      omniTypes: [0, 2, 3, 4, 5, 6, 7]
    };
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    getMediaIcon(type) {
      let icon;
      switch (type) {
        case 0:
          icon = "mdi-check-all";
          break;
        case 1:
          icon = "mdi-message";
          break;
        case 2:
          icon = "mdi-email";
          break;
        case 3:
          icon = "mdi-whatsapp";
          break;
        case 4:
          icon = "mdi-send-circle";
          break;
        case 5:
          icon = "mdi-facebook";
          break;
        case 6:
          icon = "mdi-instagram";
          break;
        case 7:
          icon = "mdi-twitter";
          break;
        default:
          icon = "mdi-message";
      }
      return icon;
    },
    omniItemProps(item) {
      return {
        title: item == 0 ? this.$t("reports.filters.all") : "",
        value: item,
        prependIcon: item != 0 ? this.getMediaIcon(item) : "",
      };
    }
  }
};
</script> 